<router-outlet></router-outlet>
<!-- <app-home></app-home> -->
<!-- <h2>Title</h2>
{{ 'FOOTER.WRITETOUS' | translate }} -->